// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"Tooltip_tooltipContainer__yvYbp","tooltipText":"Tooltip_tooltipText__ww6S2","RIGHTDOWN":"Tooltip_RIGHTDOWN__TS6NZ","LEFTDOWN":"Tooltip_LEFTDOWN__eq4mN"};